import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

/* eslint-disable no-unused-expressions */
import React, { useState, useEffect } from "react";
import { Grid, Button, DataTable, DialogFranchise, FranchiseList, FranchiseData, makeStyles, Typography, DialogViewInvoice, SMPopover } from "../../../..";
import RemoveRedEye from "@material-ui/icons/RemoveRedEye";
import { Link } from "react-router-dom";
import { ButtonGroup, MenuItem, Select } from "@material-ui/core";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      padding: "4px 25px"
    },
    divider: {
      height: "4px"
    },
    mr10: {
      "margin-right": "10px"
    },
    mr30: {
      margin: "30px"
    },
    header: {
      display: "flex",
      "align-items": "center",
      "justify-content": "space-between"
    },
    table: {
      display: "flex",
      "align-items": "top",
      "justify-content": "space-around"
    },
    charts: {
      display: "flex",
      "justify-content": "space-between",
      padding: "25px"
    },
    fcolumn: {
      "flex-direction": "column",
      "min-width": "425px"
    },
    card: {
      minHeight: "200px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    content: {
      width: "80%",
      "text-align": "center",
      margin: "20px"
    },
    cardText: {
      background: "#b7b6b682",
      width: "100%",
      minHeight: "200px",
      alignItems: "center",
      justifyContent: "center",
      display: "flex",
      borderRadius: "0 4px 4px 0",
      "flex-direction": "column",
      padding: "15px",
      "text-align": "center"
    },
    box: {
      display: "flex",
      "align-items": "center",
      "border-radius": "4px",
      border: "1px solid #7d7d7d"
    }
  };
});

var Franchises = function Franchises(_ref) {
  var data = _ref.data,
      historyData = _ref.historyData,
      columns = _ref.columns,
      historyColumns = _ref.historyColumns,
      title = _ref.title,
      options = _ref.options,
      createFranchise = _ref.createFranchise,
      editFranchise = _ref.editFranchise,
      language = _ref.language,
      dashboard = _ref.dashboard,
      taxes = _ref.taxes,
      year = _ref.year,
      getInvoicePdf = _ref.getInvoicePdf,
      handleChangeYear = _ref.handleChangeYear,
      handleSelectYears = _ref.handleSelectYears,
      compareDashboard = _ref.compareDashboard,
      locale = _ref.locale,
      translation = _ref.translation;

  // console.log("Franchises dashboard", dashboard);
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      openAddFranchise = _useState2[0],
      setOpenAddFranchise = _useState2[1];

  var classes = useStyles();

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      openEditFranchise = _useState4[0],
      setEditFranchiseOpen = _useState4[1];

  var _useState5 = useState({}),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedFranchise = _useState6[0],
      setSelectedFranchise = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      franchises = _useState8[0],
      setFranchises = _useState8[1];

  var _useState9 = useState("ALL"),
      _useState10 = _slicedToArray(_useState9, 2),
      country = _useState10[0],
      setCountry = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      compareYears = _useState12[0],
      setCompareYears = _useState12[1];

  var _useState13 = useState(["2024"]),
      _useState14 = _slicedToArray(_useState13, 2),
      years = _useState14[0],
      setYears = _useState14[1];

  var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      showHistory = _useState16[0],
      setShowHistory = _useState16[1];

  var _useState17 = useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      openView = _useState18[0],
      setOpenView = _useState18[1];

  var _useState19 = useState(null),
      _useState20 = _slicedToArray(_useState19, 2),
      selectedInvoice = _useState20[0],
      setSelectedInvoice = _useState20[1]; // console.log('data', data)


  useEffect(function () {
    setFranchises(data && _toConsumableArray(data).filter(function (franchise) {
      return country === "ALL" ? true : franchise.country === "ES";
    }).map(function (franchise) {
      return _objectSpread(_objectSpread({}, franchise), {}, {
        users: franchise.users.length
      });
    })); // console.log('first useeffect', franchises)
  }, [data]);
  useEffect(function () {
    country === "ALL" ? setFranchises(_toConsumableArray(data).map(function (franchise) {
      return _objectSpread(_objectSpread({}, franchise), {}, {
        users: franchise.users.length
      });
    })) : setFranchises(_toConsumableArray(data).filter(function (franchise) {
      return franchise.country === country;
    }).map(function (franchise) {
      return _objectSpread(_objectSpread({}, franchise), {}, {
        users: franchise.users.length
      });
    })); // console.log('country use effect', franchises)
  }, [country]);

  var handleDialogAddFranchise = function handleDialogAddFranchise() {
    setOpenAddFranchise(!openAddFranchise);
  };

  var filterData = function filterData(country) {
    return setCountry(country);
  }; // eslint-disable-next-line no-unused-expressions


  columns ? columns[3].options = {
    filter: false,
    sort: false,
    viewColumns: false,
    empty: true,
    label: false,
    customBodyRender: function customBodyRender(value, tableMeta, updateValue) {
      return /*#__PURE__*/React.createElement(Link, {
        to: "/franchises/".concat(tableMeta.rowData[0]),
        style: {
          color: "#fff"
        }
      }, /*#__PURE__*/React.createElement(RemoveRedEye, null));
    }
  } : null;

  var handleDialogEditFranchise = function handleDialogEditFranchise(id) {
    if (!openEditFranchise) {
      var franchise = data.find(function (franchise) {
        return franchise._id === id;
      });
      setSelectedFranchise(franchise);
    } else {
      setSelectedFranchise({});
    }

    setEditFranchiseOpen(!openEditFranchise);
  };

  var handleChangeYears = function handleChangeYears(e) {
    setYears(e.target.value);
    handleSelectYears(e.target.value);
  };

  var handleItemViewInvoice = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(item, id) {
      var invoice;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (openView) {
                _context.next = 7;
                break;
              }

              _context.next = 3;
              return getInvoicePdf(id);

            case 3:
              invoice = _context.sent;
              setSelectedInvoice(invoice);
              _context.next = 8;
              break;

            case 7:
              setSelectedInvoice(null);

            case 8:
              setOpenView(true);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleItemViewInvoice(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  historyColumns ? historyColumns.find(function (column) {
    return column.name === "options";
  }).options = {
    filter: false,
    sort: false,
    viewColumns: false,
    empty: true,
    label: false,
    customBodyRender: function customBodyRender(value, tableMeta, updateValue) {
      console.log(tableMeta.rowData);
      return /*#__PURE__*/React.createElement(SMPopover, {
        data: tableMeta.rowData,
        type: "invoices",
        labels: [{
          label: "View",
          name: "view",
          variant: "button",
          onItemClick: handleItemViewInvoice
        }]
      });
    }
  } : null;
  return [/*#__PURE__*/React.createElement(DialogFranchise, {
    open: openAddFranchise,
    onClose: handleDialogAddFranchise,
    variant: "add",
    createFranchise: createFranchise,
    taxes: taxes
  }), /*#__PURE__*/React.createElement(DialogFranchise, {
    open: openEditFranchise,
    onClose: handleDialogEditFranchise,
    variant: "edit",
    editFranchise: editFranchise,
    data: selectedFranchise,
    createFranchise: createFranchise,
    taxes: taxes
  }), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.header
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    style: {
      color: "#fafafa"
    }
  }, "Franchises"), /*#__PURE__*/React.createElement(ButtonGroup, {
    color: "primary",
    "aria-label": "outlined primary button group"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: year === "2020" ? "contained" : "outlined",
    onClick: function onClick() {
      handleChangeYear("2020");
    }
  }, "2020"), /*#__PURE__*/React.createElement(Button, {
    variant: year === "2021" ? "contained" : "outlined",
    onClick: function onClick() {
      handleChangeYear("2021");
    }
  }, "2021"), /*#__PURE__*/React.createElement(Button, {
    variant: year === "2022" ? "contained" : "outlined",
    onClick: function onClick() {
      handleChangeYear("2022");
    }
  }, "2022"), /*#__PURE__*/React.createElement(Button, {
    variant: year === "2023" ? "contained" : "outlined",
    onClick: function onClick() {
      handleChangeYear("2023");
    }
  }, "2023"), /*#__PURE__*/React.createElement(Button, {
    variant: year === "2024" ? "contained" : "outlined",
    onClick: function onClick() {
      handleChangeYear("2024");
    }
  }, "2024")), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    variant: showHistory ? "contained" : "outlined",
    onClick: function onClick() {
      setShowHistory(!showHistory);
    }
  }, showHistory ? "Hide history" : "Show history"), /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    className: classes.mr30,
    color: "primary",
    variant: "outlined",
    onClick: handleDialogAddFranchise
  }, "+ Add Franchise"), /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    className: classes.mr30,
    color: "primary",
    variant: "outlined",
    onClick: function onClick() {
      setCompareYears(!compareYears);
    }
  }, "Compare Years"), compareYears && /*#__PURE__*/React.createElement(Select, {
    multiple: true,
    value: years,
    onChange: handleChangeYears
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: "2020"
  }, "2020"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "2021"
  }, "2021"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "2022"
  }, "2022"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "2023"
  }, "2023"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "2024"
  }, "2024"))), /*#__PURE__*/React.createElement(FranchiseData, {
    dashboard: dashboard,
    compareDashboard: compareDashboard,
    country: country,
    compareYears: compareYears,
    years: years
  }), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.table
  }, showHistory ? /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.editor
  }, /*#__PURE__*/React.createElement(DialogViewInvoice, {
    historyView: true,
    variant: "view",
    open: openView,
    onClose: function onClose() {
      setOpenView(false);
      setSelectedInvoice(null);
    },
    invoice: selectedInvoice,
    translation: translation ? translation.dialogs.view_invoice : null,
    locale: locale
  }), /*#__PURE__*/React.createElement(DataTable, {
    key: language + "_franchises",
    columns: historyColumns,
    title: "History",
    options: options,
    data: historyData
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 3,
    className: classes.editor
  }, /*#__PURE__*/React.createElement(FranchiseList, {
    franchises: data,
    filterData: filterData
  })), country !== "all" && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 9,
    className: classes.editor
  }, /*#__PURE__*/React.createElement(DataTable, {
    key: language + "_franchises",
    type: "franchises",
    columns: columns,
    title: title,
    options: options,
    data: franchises
  }))))];
};

export default Franchises;